// @flow
export const NUMBER_OF_ATTEMPTS = 5;
export const DEFAULT_LOCALE = 'en-GB';
export const ATTEMPT_LOAD_TRANSLATIONS = 'hive/translations/ATTEMPT_LOAD_TRANSLATIONS';
export const LOAD_TRANSLATIONS = 'hive/translations/LOAD_TRANSLATIONS';



// WEBPACK FOOTER //
// ./src/core/state/translations/constants.js